module.exports = __webpack_public_path__ + "img/tcsfunding-square.407b3d8e.png";